export const appSettingsAppGroupIdQuietHoursRulesData = "/app_settings/:app_group_id/quiet_hours/rules";
